import React from 'react';
import Draggable from 'react-draggable';

import { Pedal, Overlay } from './styles';
import customBg from './custom.jpg';

interface PedalProps {
  pedal: any,
  activePedal: any
  setActivePedal: any,
  width: number,
  height: number,
}

const Component = ({ pedal, activePedal, setActivePedal, width, height }: PedalProps) => {
  const active = activePedal && activePedal === pedal.key;

  const isActive = (active: any) => {
    setActivePedal(active);
  }

  return <>
    {
      active && (
        <Overlay onClick={() => isActive(false)} />
      )
    }
    <Draggable
      handle=".handle"
      defaultPosition={{x: 0, y: 0}}
      scale={1}
      onDrag={() => {
        isActive(pedal.key);
      }}
    >
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: pedal.key === activePedal ? 999999 : 2
      }}>
        <Pedal
          className={`${active ? 'active' : ''} handle`}
          onClick={() => isActive(pedal.key)}
          style={{
            backgroundImage: !pedal.custom ? `url(https://storage.googleapis.com/hands-simulador.appspot.com/pedals/${encodeURI(pedal.brand.replace(/\//g, '-'))}/${pedal.img})` : `url(${customBg})`,
            width: pedal.custom ? width * 0.393701 : width,
            height: pedal.custom ? height * 0.393701 : height,
          }}
          // position={position}
          rotate={pedal.rotate}
          custom={pedal.custom}
        >
          {pedal.custom && (
            <div className="custom-msg">
              CUSTOM<br />
              {pedal.width} x {pedal.height} cm
            </div>
          )}
          <div className="actions" />
        </Pedal>
      </div>
    </Draggable>
  </>
}

export default Component;